export const MODULE_DEFINITIONS = {
  Home: {
    key: "/",
    label: "Home",
    permissions: "all",
    route: "/",
  },
        traffix_all_in_one: {
    key: "/traffix_all_in_one",

    label: "Traffix All In One",
    permissions: "traffix_all_in_one",
    route: "/traffix_all_in_one",
  },
  Semafix: {
    key: "/semafix",

    label: "SemaFix",
    permissions: "semafix",
    route: "/semafix",
  },
  onde_verde: {
    key: "/onde_verde",

    label: "SyncFix",
    permissions: "onde_verde",
    route: "/onde_verde",
  },
  betwin: {
    key: "/betwin",

    label: "BeTwin | Progetto Raise Spoke 4",
    permissions: "betwin",
    route: "/betwin",
  },
  AIWayport: {
    key: "/AIWayport",

    label: "AIWayport",
    permissions: "AIWayport",
    route: "/AIWayport",
  },
    Lavagna: {
    key: "/Lavagna",

    label: "Lavagna",
    permissions: "Lavagna",
    route: "/Lavagna",
  },
  signal_fix: {
    key: "/signal_fix",

    label: "SignalFix",
    permissions: "signal_fix",
    route: "/signal_fix",
  },
  mystery_client: {
    key: "/mystery_client",

    label: "MysteryX",
    permissions: "mystery_client",
    route: "/mystery_client",
  },
  sim_fix: {
    key: "/sim_fix",

    label: "SimFix",
    permissions: "sim_fix",
    route: "/sim_fix/confronto",
  },
  analysis: {
    key: "/analysis",
    label: "Analysis",
    permissions: "analysis",
    route: "/analysis",
  },
};
